import{m as o}from"./chunk-HBP5N4FR.js";o();import{CrossWindowProvider as f}from"@multiversx/sdk-web-wallet-cross-window-provider/out/CrossWindowProvider/CrossWindowProvider";export{f as a};
//# sourceMappingURL=chunk-O6HOON73.js.map
